import { ILeaderboard } from '@cp/src/reducers/leaderboardSlice';
import { ITabsOption, SelectPickerOptionProps } from '../interfaces';
import { fullMonthNames } from '@cp/src/constants/Common.constants';
import { dateFormat } from 'src/utils/DateHelper';
import { INCENTIVE_BUCKET_GROUP } from './leaderboardConstant';

export enum VIEW_MODE {
  CURRENT = 'curr',
  PREVIOUS = 'prev'
}

export interface LeaderboardProps {
  stickyBanner?: boolean;
}

export type responseDataType = {
  label: string;
  value: string;
  fill: string;
  color: string;
};

export interface CashEarnedChartHCProps extends ILeaderboard {
  titleContainerClass?: string;
  pieChartContainerClass?: string;
  animation?: boolean;
  showDropdown?: boolean;
  renderedOn?: string;
}

export const getFirstDate = () => {
  return '01';
};

export const getDayOfMonth = () => {
  return new Date().getDate();
};

export const getMonthOptions = (): Array<SelectPickerOptionProps> => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  let targetYear = currentYear;
  let targetMonth = currentMonth;
  const months = [];
  for (let i = 0; i < 12; i++) {
    if (targetMonth === 0) {
      targetMonth = 12;
      targetYear--;
    }
    if (targetMonth < 3 && targetYear === 2023) {
      return months.reverse();
    }
    months.push({
      label: `${fullMonthNames[targetMonth - 1]} ${targetYear}`,
      value: `${fullMonthNames[targetMonth - 1]}`.toUpperCase(),
      year: targetYear
    });
    targetMonth--;
  }
  return months.reverse();
};

export const getLastDate = (type: VIEW_MODE, format = 'DD MMM YYYY') => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  if (type === VIEW_MODE.CURRENT) {
    return dateFormat(date, format);
  }
  // case for January
  if (month == 0) return dateFormat(new Date(year - 1, 11, 31), format);
  return dateFormat(new Date(year, month, 0), format);
};

export const getMonth = (type: VIEW_MODE) => {
  const current = new Date();
  current.setDate(1);
  if (type == VIEW_MODE.PREVIOUS) {
    current.setMonth(current.getMonth() - 1);
    return dateFormat(current, 'MMM YYYY');
  }
  return dateFormat(current, 'MMM YYYY');
};

export const DEFAULT_OPTION = INCENTIVE_BUCKET_GROUP.TOTAL;
export const RENDERED_ON_DASHBOARD = 'dashboard';

export const tabOptions: ITabsOption[] = [
  {
    label: getMonth(VIEW_MODE.PREVIOUS),
    value: VIEW_MODE.PREVIOUS
  },
  {
    label: getMonth(VIEW_MODE.CURRENT),
    value: VIEW_MODE.CURRENT
  }
];

export const DEFAULT_OPTIONS = [
  {
    id: INCENTIVE_BUCKET_GROUP.TOTAL,
    value: INCENTIVE_BUCKET_GROUP.TOTAL,
    label: INCENTIVE_BUCKET_GROUP.TOTAL
  },
  {
    id: INCENTIVE_BUCKET_GROUP.DPD_1_TO_30,
    value: INCENTIVE_BUCKET_GROUP.DPD_1_TO_30,
    label: INCENTIVE_BUCKET_GROUP.DPD_1_TO_30
  },
  {
    id: INCENTIVE_BUCKET_GROUP.DPD_30_PLUS,
    value: INCENTIVE_BUCKET_GROUP.DPD_30_PLUS,
    label: INCENTIVE_BUCKET_GROUP.DPD_30_PLUS
  }
];
